import { Card, Col, Container, Row } from 'react-bootstrap';
import { motion } from "motion/react";
import marketData from '../../data/marketData.json';

const Packages = () => {
  const getImage = (imageName) => {
    return require(`../../assets/${imageName}`)
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section className="section-lg bg-light overflow-hidden" id="growth-services">
      <Container>
        <Row>
          <Col xs={12} className='mb-5'>
            <motion.h6 initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="underline-after position-relative text-center z-0">
              <span className="position-relative z-1 bg-white text-primary px-3">Packages</span>
            </motion.h6>
            <motion.h1 initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="d-block text-gradiant text-center fw-semibold">Pick the scope that fits</motion.h1>
          </Col>
        </Row>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <Row className="g-4">
            {marketData.packages.map((pkg) => (
              <Col lg={4} md={6} key={pkg.id}>
                <motion.div variants={cardVariants}
                  whileHover={{ y: -10, scale: 1.02, transition: { duration: 0.3 } }}
                >
                  <Card className="price-card h-100">
                    <Card.Body>
                      <div className="d-flex align-items-center mb-2">
                        <img src={getImage(pkg.image)} alt={pkg.name} height="28" className="me-2" />
                        <h5 className="card-title mb-0">{pkg.name}</h5>
                      </div>
                      <small className="text-secondary d-block mb-2">{pkg.tagline}</small>
                      <ul className="list-unstyled lh-lg mb-3">
                        {pkg.features.map((feature, idx) => (
                          <li key={idx} className="d-flex align-items-center">
                            <i className="ri-checkbox-circle-line text-success me-2"></i> {feature}
                          </li>
                        ))}
                      </ul>
                      <div className="text-secondary small mb-2">Timeline: {pkg.timeline}</div>
                      <motion.a href="#contact-market" className={`btn btn-${pkg.buttonVariant} w-100`}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                      >
                        {pkg.buttonText}
                      </motion.a>
                      <small className="d-block text-secondary text-opacity-75 mt-2">{pkg.note}</small>
                      <hr className="my-3" />
                      <div className="text-secondary small mb-2">Deliverables</div>
                      <ul className="list-unstyled lh-lg small mb-2">
                        {pkg.deliverables.map((deliverable, idx) => (
                          <li key={idx} className="d-flex align-items-center">
                            <i className={`${deliverable.icon} text-success me-2`}></i> {deliverable.text}
                          </li>
                        ))}
                      </ul>
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {pkg.addons.map((addon, idx) => (
                          <span key={idx} className="badge bg-light text-secondary border">{addon}</span>
                        ))}
                      </div>
                      {pkg.guarantee && (
                        <div className="text-secondary small mt-3">
                          <i className="ri-shield-check-line text-success me-1"></i> {pkg.guarantee}
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Packages;
